import InfoContainer from './components/infoContainer';
import CenterContainerHeader from './components/CenterContainerHeader';
import ResultsTextContainer from './components/ResultsTextContainer';
import ProjectsContainer from './components/ProjectsContainer';
import './style.css';

function App() {

  function toggleNavbar() {
    const infoContainer = document.querySelector('.info-container');
    const navbar = document.querySelector('.navbar');
    const screenModal = document.querySelector('.screen-modal');

    if (infoContainer.classList.contains("info-container-disappear")) {
      infoContainer.style.transform = "translateX(0)";
      navbar.style.display = "none";
      infoContainer.style.display = "flex";
      screenModal.style.display = "block";
    } else {
      infoContainer.style.transform = "translateX(-500px)";
      navbar.style.display = "flex";
      screenModal.style.display = "none";
    }

    infoContainer.classList.toggle("info-container-appear");
    infoContainer.classList.toggle("info-container-disappear");
  }

  return (
    <div className='app-container'>
      <div className="screen-modal" onClick={toggleNavbar}></div>
      <div className="app-inner-container">
        <div className="navbar">
          <button onClick={toggleNavbar} className="navbar-default-button">
            <i className="fas fa-ellipsis-v navbar-button"></i>
          </button>
        </div>
        <div className="info-container-wrapper">
          <InfoContainer
            toggleNavbar={toggleNavbar}
          />
        </div>
        <div className="app-center-container">
          <CenterContainerHeader />
          <div className="center-results-container">
            <ResultsTextContainer 
              firstText={"15"}
              secondText={"Month Learning Experience"}
            />
            <ResultsTextContainer 
              firstText={"3500 +"}
              secondText={"Hours Spent Learning To Code"}
            />
            <ResultsTextContainer 
              firstText={"45 +"}
              secondText={"Completed Study Projects"}
            />
          </div>
          <ProjectsContainer />
        </div>
      </div>
    </div>
  );
}


export default App;

